import {
  AddOrgClassRequest,
  DeleteOrgClassRequest,
  DeleteOrgClassesRequest,
  EditOrgClassRequest,
  UndeleteOrgClassRequest,
  AssignStudentsToClassRequest
} from "../../../../types/gqlTypes/graphql"
import {
  ADD_ORG_CLASS,
  EDIT_ORG_CLASS,
  DELETE_ORG_CLASS,
  UNDELETE_ORG_CLASS,
  DELETE_ORG_CLASSES,
  ASSIGN_STUDENTS_TO_ORG_CLASS
} from "./orgClassMutations"

import { executeMutationSideload } from "../../helpers/studyPlan"

export async function addOrgClass(data: AddOrgClassRequest): Promise<string> {
  const response = await executeMutationSideload(ADD_ORG_CLASS, { data })
  return response.addOrgClass
}

export async function editOrgClass(
  data: EditOrgClassRequest
): Promise<boolean> {
  const teacherId = data.orgRefScope?.teacherId

  const updatedClassData: EditOrgClassRequest = {
    ...data,
    ...(!!teacherId ? { teacherId } : {})
  }

  const response = await executeMutationSideload(EDIT_ORG_CLASS, {
    data: updatedClassData
  })
  return response.editOrgClass
}

export async function deleteOrgClass(
  data: DeleteOrgClassRequest
): Promise<boolean> {
  const response = await executeMutationSideload(DELETE_ORG_CLASS, { data })
  return response.deleteOrgClass
}

export async function deleteOrgClasses(
  data: DeleteOrgClassesRequest
): Promise<number> {
  const response = await executeMutationSideload(DELETE_ORG_CLASSES, { data })
  return response.deleteOrgClasses
}

export async function undeleteOrgClass(
  data: UndeleteOrgClassRequest
): Promise<boolean> {
  const response = await executeMutationSideload(UNDELETE_ORG_CLASS, { data })
  return response.undeleteOrgClass
}

export async function assignStudentsToOrgClass(
  data: AssignStudentsToClassRequest
): Promise<boolean> {
  const response = await executeMutationSideload(ASSIGN_STUDENTS_TO_ORG_CLASS, {
    data
  })
  return response.assignStudentsToOrgClass
}
